module.exports = __webpack_public_path__ + "static/media/41.b39b1fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/41.png
// module id = 465
// module chunks = 0